import React from "react";
import PageContainer from "components/lib/PageContainer";
import { Segment } from "semantic-ui-react";

import { useParams } from "react-router-dom";
import { UserContainer } from "containers";
import { StoreIdParam } from "config/raven";
import { NewFormContainer } from "components/Post/News/New/NewFormContainer";
import { StoreBreadcrumbBuilder } from "utils/breadcrumb";

export const NewsNew: React.FC = () => {
  const userContainer = UserContainer.useContainer();
  const { isAgency } = userContainer;
  const { storeId } = useParams<StoreIdParam>();

  return (
    <PageContainer
      header="お知らせ新規投稿"
      breadcrumbs={new StoreBreadcrumbBuilder(isAgency, storeId)
        .newsPage()
        .build("お知らせ新規投稿")}
    >
      <Segment>
        <NewFormContainer isAgency={isAgency} storeId={storeId} />
      </Segment>
    </PageContainer>
  );
};
